import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import StudentAuditLog, { Props } from "./StudentAuditLog.vue";
import ErrorGuard from "@/components/ErrorGuard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StudentAuditLogWrapper',
  props: {
    cohortId: {},
    memberId: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ErrorGuard, null, {
    default: _withCtx(() => [
      _createVNode(StudentAuditLog, _normalizeProps(_guardReactiveProps(props)), null, 16)
    ]),
    _: 1
  }))
}
}

})